import { jsxs as j, jsx as g } from "react/jsx-runtime";
import * as v from "react";
import { forwardRef as C, useRef as x, useState as O, useImperativeHandle as D, useEffect as P } from "react";
import { c as S } from "./index.js-Cr0Rsuyz.mjs";
import { e as A } from "./extract-responsive-property-BiJ5BiwI.mjs";
import { c as z } from "./tw-cn-mXgPecoF.mjs";
import { c as w } from "./index-BpNK5r1N.mjs";
function q(e, a) {
  return /* @__PURE__ */ v.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: a
  }, e), /* @__PURE__ */ v.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.028 6.681a1.67 1.67 0 0 1 2.362 2.363l-9.06 9.06a1.5 1.5 0 0 1-2.121 0l-5.354-5.353a1.492 1.492 0 1 1 2.11-2.11l3.91 3.91a.2.2 0 0 0 .283 0z",
    clipRule: "evenodd"
  }));
}
var F = S(/* @__PURE__ */ C(q));
function H(e, a) {
  return /* @__PURE__ */ v.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: a
  }, e), /* @__PURE__ */ v.createElement("path", {
    fill: "currentColor",
    d: "M4 12.11c0-.89.72-1.61 1.61-1.61h12.78a1.61 1.61 0 1 1 0 3.219H5.61A1.61 1.61 0 0 1 4 12.109"
  }));
}
var K = S(/* @__PURE__ */ C(H));
const B = w(["relative inline-block"], {
  variants: {
    size: {
      medium: "size-24",
      small: "size-20"
    },
    pcSize: {
      medium: "pc:size-24",
      small: "pc:size-20"
    }
  }
}), T = w(
  [
    "focus:ring-green-500 peer size-full appearance-none rounded-4 cursor-pointer",
    "bg-static-white border border-line-neutral-medium",
    "checked:border-none disabled:cursor-not-allowed"
  ],
  {
    variants: {
      state: {
        checked: [
          "checked:bg-static-black checked:hover-never:bg-interaction-neutral-presshover-strong1 checked:active:bg-interaction-neutral-presshover-strong1",
          "disabled:bg-interaction-neutral-disable-main disabled:hover-never:bg-interaction-neutral-disable-main disabled:active:bg-interaction-neutral-disable-main"
        ],
        empty: [
          "checked:bg-static-black hover-never:bg-interaction-neutral-presshover-weak1 checked:active:bg-interaction-neutral-presshover-weak1",
          "disabled:bg-fill-neutral-weak disabled:hover:bg-fill-neutral-weak disabled:border-interaction-neutral-disable-main"
        ],
        indeterminate: [
          "bg-static-black border-none hover-never:bg-interaction-neutral-presshover-strong1 active:bg-interaction-neutral-presshover-strong1",
          "disabled:bg-interaction-neutral-disable-main disabled:hover-never:bg-interaction-neutral-disable-main disabled:active:bg-interaction-neutral-disable-main"
        ]
      }
    },
    defaultVariants: {
      state: "empty"
    }
  }
), E = w(
  ["pointer-events-none absolute text-static-white", "left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"],
  {
    variants: {
      state: {
        default: "opacity-0 peer-checked:opacity-100",
        indeterminate: ""
      },
      size: {
        medium: "size-20",
        small: "size-16"
      },
      pcSize: {
        medium: "pc:size-20",
        small: "pc:size-16"
      }
    },
    defaultVariants: {
      state: "default"
    }
  }
), c = {
  Checked: "checked",
  Indeterminate: "indeterminate",
  Empty: "empty"
}, V = C((e, a) => {
  const {
    className: t,
    style: l,
    checked: n,
    indeterminate: r,
    disabled: u,
    type: h = "checkbox",
    size: m,
    onChange: i,
    ...p
  } = e, o = x(null), d = x(null), [b, f] = O(() => r ? c.Indeterminate : n ? c.Checked : c.Empty), k = A({
    property: m,
    mobileKey: "size",
    pcKey: "pcSize",
    defaultValue: {
      mobile: "small",
      pc: "medium"
    }
  }), I = B({ ...k }), R = T({ state: b });
  D(a, () => ({
    focus: (s) => {
      var y;
      (y = o.current) == null || y.focus(s);
    },
    blur: () => {
      var s;
      (s = o.current) == null || s.blur();
    },
    input: o.current,
    nativeElement: d.current
  }));
  const N = (s) => {
    u || (f(s.target.checked ? c.Checked : c.Empty), i == null || i({
      target: {
        ...e,
        type: h,
        checked: s.target.checked
      },
      stopPropagation() {
        s.stopPropagation();
      },
      preventDefault() {
        s.preventDefault();
      },
      nativeEvent: s.nativeEvent
    }));
  };
  return P(() => {
    f(r ? c.Indeterminate : n ? c.Checked : c.Empty);
  }, [n, r]), /* @__PURE__ */ j("span", { className: z(I, t), ref: d, style: l, children: [
    /* @__PURE__ */ g(
      "input",
      {
        ...p,
        checked: b === c.Checked,
        className: z(R, I),
        disabled: u,
        onChange: N,
        ref: o,
        type: h
      }
    ),
    b === c.Checked && /* @__PURE__ */ g(F, { className: E({ ...k }) }),
    b === c.Indeterminate && /* @__PURE__ */ g(K, { className: E({ ...k, state: "indeterminate" }) })
  ] });
});
V.displayName = "NDS.Checkbox";
const G = (e, a, t, l) => {
  const n = { ...e }, r = (u, h, m) => {
    Object.values(n).forEach((i) => {
      i.parentId === u && (n[i.id] = { ...i, checked: h, indeterminate: m }, i.hasChildren && r(i.id, h, m));
    });
  };
  return r(a, t, l), n;
}, M = (e, a) => {
  const t = { ...e }, l = (n) => {
    const r = t[n];
    if (!r.parentId)
      return;
    const u = t[r.parentId], h = Object.values(t).filter((d) => d.parentId === r.parentId), m = h.every((d) => d.checked), i = h.every((d) => !d.checked && !d.indeterminate);
    let p = !1, o = !1;
    m ? (p = !0, o = !1) : i ? (p = !1, o = !1) : (p = !1, o = !0), t[u.id] = { ...u, checked: p, indeterminate: o }, l(u.id);
  };
  return l(a), t;
}, Q = (e, a) => {
  switch (a.type) {
    case "TOGGLE_CHECKED": {
      const t = e[a.id];
      if (!t) return e;
      const l = {
        ...e,
        [a.id]: { ...t, checked: !t.checked, indeterminate: !1 }
      }, n = l[a.id];
      let r = l;
      return n.hasChildren && (r = G(r, n.id, n.checked, n.indeterminate)), n.parentId && (r = M(r, n.id)), r;
    }
    default:
      return e;
  }
}, Y = (e) => Object.values(e).filter((t) => t.type === "required").every((t) => t.checked);
export {
  V as C,
  Y as i,
  Q as n
};
